import React, { memo } from 'react'
import tw from 'twin.macro'
import { Typography } from '@mui/material'
import { useFormikContext } from 'formik'
import { FormikTextField } from 'src/components/shared/form/formik/FormikTextField'
import { remoteConfigAppTitles } from 'src/constants/remote-config/remoteConfig'
import type {
  DeleteRemoteConfigFormValues,
  RemoteConfig,
  RemoteConfigFormStatus,
} from 'src/interfaces/remoteConfig'

interface Props {
  remoteConfig: RemoteConfig
}

const DeleteRemoteConfigFormContentComponent = ({ remoteConfig }: Props) => {
  const { status } = useFormikContext<DeleteRemoteConfigFormValues>()
  const formStatus = status as RemoteConfigFormStatus | undefined

  return (
    <div css={tw`flex flex-col gap-4`}>
      <Typography variant="body2">
        This deletes {remoteConfig.key} from the {remoteConfigAppTitles[remoteConfig.app]}. The app
        gets its in-code default from its next load.
      </Typography>
      <FormikTextField<DeleteRemoteConfigFormValues>
        name="confirmText"
        label={`Type ${remoteConfig.key} to confirm`}
        placeholder={remoteConfig.key}
        autoComplete="off"
        fullWidth
      />
      {formStatus?.formError ? (
        <Typography variant="body2" role="alert" css={tw`text-critical-500`}>
          {formStatus.formError}
        </Typography>
      ) : null}
    </div>
  )
}

export const DeleteRemoteConfigFormContent = memo(DeleteRemoteConfigFormContentComponent)
